<template>
  <div class="modal fade" id="tooltip" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="d-flex justify-content-between">
            <p class="modal-title font-weight-bold">{{ title }}</p>
            <button type="button" class="close" data-dismiss="modal" :aria-label="closeText">
              <img width="18px" :src="require('@/assets/times.svg')" :alt="closeText" />
            </button>
          </div>
          <p class="tooltip-body" v-html-safe="body"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    body: {
      type: String,
    },
  },
  computed: {
    closeText() {
      return this.$t('message.popup.leave');
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  color: white;
  font-size: 14px;
  margin: 0;
}
.modal-content {
  background-color: #4b5863;
}
.modal-body {
  padding: 20px 20px 24px 20px;
}
.tooltip-body {
  padding-right: 15px;
}
.close {
  position: absolute;
  right: 13px;
  top: 8px;
  img {
    filter: invert(98%) sepia(4%) saturate(1087%) hue-rotate(235deg) brightness(125%) contrast(100%);
  }
}
</style>
